<sm-title-bar pageTitle="{{ 'privacy_settings.title' | translate }}" > </sm-title-bar>

<div class="merchant_detail_sec" *ngIf="!loader">
  <div class="mrt_offe">
    <div class="row">
   
      <div class="col-sm-12">
        <div class="list_user" >
          <div class="admin_category">
          
            <div class="card_header chead">
              <div class="privecy_heading">
                <h3>Privacy </h3>
              </div>
              <div class="adm_set" style="display: block !important;">
                <div>
                  <span class="name_cont">{{ 'privacy_settings.h1' | translate }}</span>
                  <mat-slide-toggle class="share" (change)="onToggleChangeProfile($event)" [checked]="toShowCheckProfile === 0"></mat-slide-toggle>
                  <h3 style="margin-top: 0px;
                  color: #707070;
                  font-size: 13px;
                  margin-bottom: 0px;"  >{{ 'privacy_settings.txt1' | translate }}</h3>
                  <h4 style="margin-bottom: 0; font-size: 14px;    margin-top: -5px;">{{ 'privacy_settings.current_status' | translate }}: <span class="publ_cvb"> 
                    <mat-icon *ngIf="userDetail.isPrivate == 0" style="color: #22cc0a">public</mat-icon>
                    <mat-icon *ngIf="userDetail.isPrivate != 0">public</mat-icon>
                    
                    {{userDetail.isPrivate == 0 ? 'Public' : 'Private'}}</span></h4>
                </div>
              </div>
            </div>
            <div class="card_header chead">
              <div class="adm_set" style="display: block !important;">
                <div>
                  <span class="name_cont">{{ 'privacy_settings.h2' | translate }}</span>
                  <mat-slide-toggle class="share" (change)="onToggleChangeNotifications($event)" [checked]="toShowCheckNotifications === 0"></mat-slide-toggle>
                  <h3 style="margin-top: 2px;
                  color: #666666;
                  font-size: 13px;
                  margin-bottom: 0px;">{{ 'privacy_settings.txt2' | translate }}</h3>
                  <h4 style="margin-bottom: 0; font-size: 14px;    margin-top: -5px;">{{ 'privacy_settings.current_status' | translate }}: <span class="publ_check">
                     <mat-icon *ngIf="userDetail.doNotDisturb == 0">check_circle</mat-icon>
                     <mat-icon *ngIf="userDetail.doNotDisturb != 0" style="color: #e60505">cancel</mat-icon>
                      {{userDetail.doNotDisturb == 0 ? 'Active' : 'Not active'}}</span></h4>
                </div>
              </div>
            </div>
            <!-- 3rd -->
            <!-- <div class="card_header chead">
              <div class="adm_set" style="display: block !important;">
                <div>
                  <span class="name_cont">Email recieve/subscription</span>
                  <mat-slide-toggle class="share"></mat-slide-toggle>
                  <h3 style="margin-top: 2px;color: #666666;font-size: 13px;margin-bottom: 0px;">Set this setting to receive or shop emails.</h3>
                  <h4 style="margin-bottom: 0; font-size: 14px;">Current status: <span class="publ_check">
                     <mat-icon>check_circle</mat-icon>
                     Active</span></h4>
                </div>
              </div>
            </div> -->
          </div>
        </div>



        <div class="drt_head">
        </div>

        <!-- phone number change UI -->

        <div class="list_user">
          <div class="admin_category">
            <div class="card_header chead">
              <div class="adm_set">
                <div>
                  <div class="impo_heading">
                      <h2>Phone number change</h2>
                      <p>Start the changing process by providing the new phone number. You'll going to get an OTP on the new number for verification purpose. Provide the OTP in the required section and verify it. Your new number will be added in system. A re-login will be prompted at the last stage.</p>
                  </div>
                </div>
              </div>
              <div class="privancy_sett_btn">
                <button mat-flat-button color="primary" (click)="changeNumber()" class="fixed-icon-btn">
                  <span class="button-text">Change phone</span>
                 
                </button>
                
                
               
                </div>
            </div>
          </div>
        </div>

        


        <!--  -->

        <div class="list_user" >
            <div class="card_header chead">
              <!-- <div class="adm_set" style="margin-bottom: 18px;">
                <div>
                  <span class="name_cont">De-activate account</span>
                  <h3 style="margin-top: 0px;
                   font-size: 14px;
                   color: #3a3a3a;
                  margin-bottom: 0px;
                  line-height: 22px;
                  padding-top: 8px;">{{ 'privacy_settings.h3_txt' | translate }}</h3>
                </div>
              </div> -->
              <div class="impo_heading">
                <h2>De-activate account</h2>
                <p>{{ 'privacy_settings.h3_txt' | translate }}</p>
              </div>
              <div class="privancy_sett_btn">
                <button mat-flat-button color="primary" (click)="openDeactivate()">
                  <span>De-activate</span>
                 
                </button>
                
               
                </div>
  
            </div>
            <!-- <div class="privacy_setting_sec">
              <div style="background: #ffc107;border-radius: 0px 0px 10px 10px;" (click)="openDeactivate()">
                <div class="cdf_srd">
                  <div class="book_text" >
                      <div class="entry_sec">
                          <mat-icon style="color:#222">navigate_next</mat-icon>
                      </div>
                      <p style="color:black">De-activate</p>
                  </div>
              </div>
              </div> 
            </div> -->

           

        </div>

        <!--  -->




      </div>
      <!-- right side -->
     


    </div>
  </div>
</div>
